import { compose } from "redux";
import component from "./index.component";
import withCurrentUser from "lib/containers/withCurrentUser";
import { withRouter } from "react-router";

export default compose(withCurrentUser, withRouter)(component);
